import React, { memo, useCallback, useState } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { usePopper } from 'react-popper'

import icons from 'components/MoneyUnit/icons'
import HelpDialog from 'components/Shared/HelpDialog'

const VARIANTS = [
  'default',
  'arrow',
  'employee',
  'building',
  'top-bar',
  'bordered',
  'account-receivables',
  'finances',
  'rd',
  'procurement'
]

function MoneyUnit(props) {
  const { animation, coins, variant, className, hoverInformation } = props

  const { t } = useTranslation()

  const [showHelp, setShowHelp] = useState(false)
  const [referenceElement, setReferenceElement] = useState(null)
  const [popperElement, setPopperElement] = useState(null)
  const { styles } = usePopper(referenceElement, popperElement)

  const variantClass = variant ? `money-unit--${variant}` : ''
  const iconMoneyUnit = icons[variant]
  const isArrow = variant === 'arrow'
  const isQuarter = variant === 'quarter-xl' || variant === 'quarter-lg'

  const toggleHelp = useCallback(() => {
    if (hoverInformation) {
      setShowHelp((old) => !old)
    }
  }, [hoverInformation])

  return (
    <div
      className={`money-unit ${variantClass} ${className}`}
      onMouseEnter={toggleHelp}
      onMouseLeave={toggleHelp}
      ref={setReferenceElement}
    >
      {isArrow && <span className="money-unit__q">{t('top_bar.ar_q1')}</span>}
      <img
        src={iconMoneyUnit}
        className={`money-unit__icon ${animation.enabled ? 'animated' : ''}`}
        alt="Money unit"
        onAnimationEnd={animation.onAnimationEnd}
      />
      <div className="money-unit__box">
        <span className="money-unit__amount">{coins}</span>
        <span className="money-unit__mu">
          {isQuarter ? t('general.quarters') : t('general.mu')}
        </span>
      </div>
      {showHelp ? (
        <div className="money-unit__popper" style={styles.popper} ref={setPopperElement}>
          <HelpDialog title={hoverInformation.title} description={hoverInformation.description} />
        </div>
      ) : null}
    </div>
  )
}

MoneyUnit.propTypes = {
  animation: PropTypes.shape({
    enabled: PropTypes.bool,
    onAnimationEnd: PropTypes.func
  }),
  coins: PropTypes.number.isRequired,
  variant: PropTypes.oneOf(VARIANTS),
  className: PropTypes.string,
  hoverInformation: PropTypes.shape({
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired
  })
}

MoneyUnit.defaultProps = {
  animation: {},
  variant: VARIANTS[0],
  className: '',
  hoverInformation: null
}

export default memo(MoneyUnit)
